module.exports = __webpack_public_path__ + "static/media/volume-mute.776f1f47.svg";